import { PieChartProperty } from '@src/slide/domain/ui-model/element-modeles/property/chart/sub-chart/pie-chart';
import type {
    IDoughnutChartProperty,
} from '@src/slide/domain/ui-model/element-modeles/property/chart/sub-chart/doughnut-chart.interface';
import type { IDoughnutChart } from '@src/slide/domain/ui-model/element-modeles/Interface/chart-v3/sub-chart';
import { SubChartType } from '../../../Interface/chart-v3/sdk-model.interface';

export class DoughnutChartProperty extends PieChartProperty<IDoughnutChart> implements IDoughnutChartProperty {
    public get holeSize(): number {
        return this.uiData.holeSize ?? 0;
    }

    public get firstSliceAngle(): number  {
        return this.uiData.firstSliceAngle ?? 0;
    }

    public updateAngleOfFirstSlice(value: number, onlyChangeUI?: boolean) {
        const subChartModel = this.context.getSubChartModel() as IDoughnutChart;
        if (subChartModel.originType !== SubChartType.DoughnutChart) return;
        if (onlyChangeUI) {
            subChartModel.firstSliceAngle = value;
            return;
        }
        subChartModel.updateProps({ firstSliceAngle: value });
    }

    public getAngleOfFirstSlice(): number | undefined {
        const subChartModel = this.context.getSubChartModel() as IDoughnutChart;
        if (subChartModel.originType !== SubChartType.DoughnutChart) return;
        return subChartModel.firstSliceAngle;
    }

    public getDoughnutHoleSize(): number | undefined {
        const subChartModel = this.context.getSubChartModel() as IDoughnutChart;
        if (subChartModel.originType !== SubChartType.DoughnutChart) return;
        return subChartModel.holeSize;
    }

    public updateDoughnutHoleSize(value: number, onlyChangeUI?: boolean) {
        const subChartModel = this.context.getSubChartModel() as IDoughnutChart;
        if (subChartModel.originType !== SubChartType.DoughnutChart) return;
        if (onlyChangeUI) {
            subChartModel.holeSize = value;
            return;
        }
        subChartModel.updateProps({ holeSize: value });
    }
}
